import React, { useState, useEffect, useRef } from "react";
import { ArrowsUpDownIcon } from '@heroicons/react/24/solid';

const MapComponent = React.memo(({ parcel_code, longitude, latitude }) => {
    const mapRef = useRef(null);
    const [isSatellite, setIsSatellite] = useState(true);

    useEffect(() => {
        let google = window.google;
        let map = mapRef.current;
        const zoom =  latitude ? 19 : 13;

        const mapOptions = {
            zoom: zoom,
            scrollwheel: false,
            zoomControl: true,
            styles: [
                {
                    featureType: "administrative",
                    elementType: "labels.text.fill",
                    stylers: [{color: "#444444"}],
                },
                {
                    featureType: "landscape",
                    elementType: "all",
                    stylers: [{color: "#f2f2f2"}],
                },
                {
                    featureType: "poi",
                    elementType: "all",
                    stylers: [{visibility: "off"}],
                },
                {
                    featureType: "road",
                    elementType: "all",
                    stylers: [{saturation: -100}, {lightness: 45}],
                },
                {
                    featureType: "road.highway",
                    elementType: "all",
                    stylers: [{visibility: "simplified"}],
                },
                {
                    featureType: "road.arterial",
                    elementType: "labels.icon",
                    stylers: [{visibility: "off"}],
                },
                {
                    featureType: "transit",
                    elementType: "all",
                    stylers: [{visibility: "off"}],
                },
                {
                    featureType: "water",
                    elementType: "all",
                    stylers: [{ color: "#91b1d6" }, { visibility: "on" }],
                },
            ],
            disableDefaultUI: true,
            //gestureHandling: "none",
            mapTypeId: isSatellite ? "satellite" : "roadmap",
            restriction: {
                latLngBounds: {
                    north: 29.644539652951327,
                    south: 29.323958416041393,
                    east: -104.09821543483643,
                    west: -104.74217045964511,
                },
            },
        };

        map = new google.maps.Map(map, mapOptions);

        let lat = latitude || "29.548060";
        let lng = longitude || "-104.417663";

        const centerLatLng = new google.maps.LatLng(lat, lng);
        map.setCenter(centerLatLng);

        if (parcel_code) {
            map.data.loadGeoJson(`/lots/${parcel_code}/geojson.json`);

            map.data.setStyle(() => ({
                fillColor: isSatellite ? "#2196f3" : "#2196f3",
                strokeWeight: 2,
                strokeColor: "#1766A6",
                fillOpacity: 0.4,
            }));
        }

        // Handle view change
        google.maps.event.addListener(map, "maptypeid_changed", () => {
            const currentView = map.getMapTypeId();
            setIsSatellite(currentView === "satellite");
        });

    }, [isSatellite]);

    const toggleMapView = () => {
        setIsSatellite((prev) => !prev);
    };

    return (
        <>
            <div className="relative w-full rounded h-full">
                <div className="rounded h-full" ref={mapRef}/>
                <button
                    onClick={toggleMapView}
                    className="absolute top-0 right-0 p-2 bg-white text-gray rounded text-sm flex items-center space-x-1"
                >
                    <ArrowsUpDownIcon className="w-4 h-4 text-gray-800 mr-1"/>
                    <span className="text-xs font-semibold">{isSatellite ? "Satelital" : "Normal"}</span>
                </button>
            </div>
        </>
    );
});

export default MapComponent;
